
<div class="page-breadcrumb">
    <div class="row">
        <div class="col-7 align-self-center">
            <!-- <div class="d-flex align-items-center">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <a rouetLink="/mainview/dashboard" class="link">Dashboard</a>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page"> vendor Masters Management</li>
                    </ol>
                </nav>
            </div> -->
            <h4 class="page-title">Vendor Product Management</h4>
        </div>

    </div>
</div>
<div class="container-fluid" style="margin-top: 20px">

    <!-- ============================================================== -->
    <!-- Start Page Content -->
    <!-- ============================================================== -->
    <div class="row">
        <!-- Column -->
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="table-responsive">
                        <div id="zero_config_wrapper"
                            class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                            <diV class="row">
                                <div class="col-md-10">
                                    <label>Vendor Products Management</label>
                                </div>
                                <div class="col-md-1">
                                    <div id="zero_config_filter" class="dataTables_filter">
                                        <button style="background-color: #e0e09e" (click)="filter()" >
                                            <i class="fa fa-filter" aria-hidden="true"></i>
                                            Filter</button>
                                    </div>
                                </div>
                                <div class="col-md-1">
                                    <div id="zero_config_filter" class="dataTables_filter">
                                        <button style="background-color: #e0e09e" (click)="exportTable()" >
                                            <i class="fa fa-download" aria-hidden="true"></i>
                                            Export</button>
                                    </div>
                                </div>
                            </diV>
                            <div *ngIf="showFilter" style="background-color: #e0e09e;width: 895px;">
                                <div class="container-fluid" style="color: black">
                                    <input type="radio" id="emailId" name="gender" 
                                        value="ei" style="margin-top: 29px;" (change)="applyCustomizedFilter()"  [(ngModel)]="filterValueSelected"> Account Email Id &nbsp;&nbsp;
                                    <input type="radio" id="name" name="gender" [(ngModel)]="filterValueSelected"
                                        value="pn" (change)="applyCustomizedFilter()"> Product Name &nbsp;&nbsp;
                                    <input type="radio" id="vendorname" name="gender" [(ngModel)]="filterValueSelected"
                                        value="pkw" (change)="applyCustomizedFilter()">Product Key Words&nbsp;&nbsp;
                                    <input type="radio" id="gstin " name="gender" [(ngModel)]="filterValueSelected"
                                        value="vn" (change)="applyCustomizedFilter()"> Vendor name &nbsp;&nbsp;
                                </div>
                                <div style="margin-left: 820px">
                                    <button class="btn btn-dark" (click)="filter()">Cancel</button>
                                </div>
                            </div>
                            <div>
                                <div>
                                    <mat-form-field *ngIf="showCustomisedSearch">
                                        <input class="search" placeholder="Search" matInput [(ngModel)]="searchValue"
                                            (keyup)="applyCustomizedFilterSearch(searchValue)">
                                    </mat-form-field>
                                    <mat-form-field *ngIf="!showCustomisedSearch">
                                        <input class="search" placeholder="Search" matInput (keyup)="applyFilter($event.target.value)">
                                    </mat-form-field>
                                </div>
                                <div class="table-responsive">
                                    <table class="table" id="Example table" mat-table
                                        [dataSource]="dataSource" matSort style=" margin-top: 30px;">
                                        <ng-container matColumnDef="accountDetails.vendorName">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Vendor Name</th>
                                            <td *matCellDef="let row">
                                                {{row.accountDetails.vendorName}}
                                            </td>
                                        </ng-container>
                                       
                                        <ng-container matColumnDef="accountEmailId">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Account Email ID</th>
                                            <td *matCellDef="let row">
                                                {{row.accountEmailId}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="productName">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Name</th>
                                            <td *matCellDef="let row">
                                                {{row.productName}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="productImage">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Image</th>
                                            <td *matCellDef="let row" style="white-space: nowrap;">
                                              
                                                <button class="dropdown-item" data-toggle="modal"
                                               data-target="#responsiveImages"
                                                style="color:rgb(30, 110, 124)" (click)="viewImages(row._id)">
                                               View
                                                </button>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="description">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Description</th>
                                            <td *matCellDef="let row">
                                                {{row.description}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="keyWords">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Product keyWords
                                            </th>
                                            <td *matCellDef="let row">
                                                {{row.keyWords}}
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="stockQuantity">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Stock Quantity</th>
                                            <td *matCellDef="let row">
                                                {{row.stockQuantity}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="stockUnit">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Stock Unit</th>
                                            <td *matCellDef="let row">
                                                {{row.stockUnit}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="actualPrice">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Actual Price</th>
                                            <td *matCellDef="let row">
                                                {{row.actualPrice}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="offeredPrice">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Offer Price
                                            </th>
                                            <td *matCellDef="let row">
                                               {{row.offeredPrice}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="expiryDate">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Expiry Date</th>
                                            <td *matCellDef="let row">
                                                {{row.expiryDate|date}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="category">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Category
                                            </th>
                                            <td *matCellDef="let row">
                                                {{row.category}}
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="subCategory">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Sub Category</th>

                                            <td *matCellDef="let row">
                                                {{row.subCategory}}
                                            </td>
                                        </ng-container>
                                        <tr mat-header-row *matHeaderRowDef='displayedColumns'>
                                        </tr>
                                        <tr mat-row *matRowDef="let row;columns:displayedColumns"></tr>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </div>
                    <mat-paginator style="margin-right:200px" [length]="100" [pageSize]="10"
                        [pageSizeOptions]="[5, 10, 25,100]" showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>
        </div>
        <!-- Column -->
    </div>
    <!-- ============================================================== -->
    <!-- End PAge Content -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Right sidebar -->
    <!-- ============================================================== -->
    <!-- .right-sidebar -->
    <!-- ============================================================== -->
    <!-- End Right sidebar -->
    <!-- ============================================================== -->
</div>
<div id="responsiveImages" class="modal fade" tabindex="-1" data-width="760" style="display: none;">
    <div class="modal-dialog" id="box" style="margin-left: 300px">
        <div class="modal-content" style="width:900px">
            <div class="modal-header">
                <button type="button" class="close btn-danger" data-dismiss="modal">X
                </button>
            </div>
            <div class="modal-body">
                <img style="text-indent: -10000px"  src="{{myurl+'Misc/Images/vendorProductImages/'+productImageId+'_0'}}"
                width="100" height="100" />
                <img   style="text-indent: -10000px" src="{{myurl+'Misc/Images/vendorProductImages/'+productImageId+'_1'}}"
                width="100" height="100" />
                <img  style="text-indent: -10000px"  src="{{myurl+'Misc/Images/vendorProductImages/'+productImageId+'_2'}}"
                width="100" height="100" />
                <img style="text-indent: -10000px"  src="{{myurl+'Misc/Images/vendorProductImages/'+productImageId+'_3'}}"
                width="100" height="100" />
                <img   style="text-indent: -10000px" src="{{myurl+'Misc/Images/vendorProductImages/'+productImageId+'_4'}}"
                width="100" height="100" />
                <img  style="text-indent: -10000px"  src="{{myurl+'Misc/Images/vendorProductImages/'+productImageId+'_5'}}"
                width="100" height="100" />
                <img style="text-indent: -10000px"  src="{{myurl+'Misc/Images/vendorProductImages/'+productImageId+'_6'}}"
                width="100" height="100" />
                <img   style="text-indent: -10000px" src="{{myurl+'Misc/Images/vendorProductImages/'+productImageId+'_7'}}"
                width="100" height="100" />
 
            </div>
        </div>
    </div>
</div>